import React, { useEffect, useState} from 'react'
import styles from './WorkReportingTemplates.module.css'
import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {
    Alert,
    Grid, IconButton
} from "@mui/material";
import {DataGridPremium, GridRowParams, MuiEvent} from "@mui/x-data-grid-premium";
import {GridCallbackDetails, GridCellParams, GridColDef, GridToolbarContainer} from "@mui/x-data-grid-pro";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import FindWorkOrder from "./FindWorkOrder";
import dayjs from "dayjs";
import CreateSchedule from "./CreateSchedule";
import {Delete} from "@mui/icons-material";

const WorkReportingTemplates = (params) => {
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [findWorkOrder, setFindWorkOrder] = React.useState(false)
    const [createScheduleShow, setCreateScheduleShow] = React.useState(false)
    const [scheduleCreate, setScheduleCreate] = React.useState(false)
    const [woid, setWoid] = React.useState<number>(0)
    const [templateData, setTemplateData] = useState([])
    const [workReportingData, setWorkReportingData] = useState([])
    const [dialogMsg, setDialogMsg] = React.useState( '');
    const [dialogObj, setDialogObj] = React.useState({ msg: "", id: 0 })
    const [rowTemplateData, setTemplateRowData] = React.useState( {templateid: null, templatetitle: '', templatedescription: "", requireswo: false});

    useEffect(() => {
        params.setTitle('Work Reporting Template')
        getData()
    }, [])

    useEffect(() => {
        if (woid > 0 || scheduleCreate == true) {
            setScheduleCreate((prevState) => {
                return false
            })
            createSchedule(rowTemplateData)
        }
    }, [woid, scheduleCreate])

    const getData = () => {
        setLoadingBackdrop(true)
        axios.get(`workreportingtemplate`).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            console.log(dataJson)
            const templateDataList = dataJson?.templatelist?.map((item) => {
                return {...item, id: item.templateid}
            })

            var tempId = 0;
            const workReportingList = dataJson?.workreportinglist?.map((item) => {
                tempId = 1 + tempId
                return {...item, id: tempId}
            })

            setTemplateData(templateDataList)
            setWorkReportingData(workReportingList)
            setLoadingBackdrop(false)
        }).catch(error => {
            console.log(error.response)
            if (error.response?.status?.length > 0) {
                setDialogMsg(error?.response?.status)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            setLoadingBackdrop(false)
        })
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const createSchedule = (formData) => {
        setLoadingBackdrop(true)

        var body = {templateid: formData?.templateid}
        if (woid != null) {
            body['woid'] = woid
        }

        axios.post(`workreportingschedule`, body).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            console.log(dataJson)
            getData()
        }).catch(error => {
            setLoadingBackdrop(false)
            if (error.response) {
                setDialogMsg(error?.response?.data?.title)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            setLoadingBackdrop(false)
        })
    }

    useEffect(()=> {
        if (rowTemplateData?.templateid > 0) {
            if (rowTemplateData.requireswo) {
                setFindWorkOrder(true)
            }
            else {
                setWoid(prevState => {
                    return null
                })
                setCreateScheduleShow(true)
            }
        }
    }, [rowTemplateData])

    const handleRowClick = (param : GridRowParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        const newRowData = {...param?.row}
        setTemplateRowData(newRowData)
    }

    const closeDialog = () => {
        setDialogMsg("")
        setDialogObj({
            msg: '',
            id: 0
        })
    }

    const handleDelete = (params: GridCellParams) => {
        setDialogObj({
            msg: 'Are you sure you want to delete \"' + params.row.workreportingtemplatetitle + "\"?",
            id: params.row.workreportingid
        })
    }

    const deleteDialog = async () => {
        await handleDeleteConfirm(dialogObj.id)
    }
    const handleDeleteConfirm = async (id: number) => {
        var body = {
            "workreportingid": id,
        }

        const { data } = await axios.delete('/workreportingschedule', {data: body})
        const parsedData = JSON.parse(data.jsonString)

        if (parsedData.status === "failure") {
            setDialogObj({
                msg: '',
                id: 0
            })
            setDialogMsg(parsedData.message)
        }
        else {
            getData()
            setDialogObj({
                msg: '',
                id: 0
            })
        }
    }

    const columns: GridColDef[] = [
        {
            field: 'templatetitle',
            type: 'string',
            headerName: 'Template Title',
            width: 300,
            align: 'left',
            headerAlign: 'left',
        },
        {
            field: 'templatedescription',
            type: 'string',
            headerName: 'Template Description',
            width: 420
        },
        {
            field: 'requireswo',
            type: 'boolean',
            headerName: 'Requires Work Order',
            align: 'center',
            headerAlign: 'left',
            width: 170,
        },
    ]

    const workreportingcolumns: GridColDef[] = [
        {
            field: 'workreportingtemplatetitle',
            type: 'string',
            headerName: 'Template Title',
            width: 300,
            align: 'left',
            headerAlign: 'left',
        },
        {
            field: 'workreportingwoid',
            type: 'string',
            headerName: 'WO #',
            align: 'right',
            width: 100,
            valueFormatter: (params) =>
                (params.value ? params.value : '')
        },
        {
            field: 'workreportingcustomerworkorder',
            type: 'string',
            headerName: 'Customer #',
            align: 'right',
            width: 260
        },
        {
            field: 'workreportingdatecreated',
            type: 'date',
            headerName: 'Created',
            width: 125,
            align: 'right',
            valueFormatter: (params) =>
                (params.value ? dayjs(params?.value?.toString(), "YYYY-MM-DD").format('MM/DD/YYYY') : 'N/A')
        },
        {
            field: 'workreportingurl',
            type: 'string',
            headerName: 'Work Reporting App',
            align: 'center',
            width: 300,
            renderCell: (params) => (
                <a href={params.row.workreportingurl} target="_blank" rel="noopener noreferrer">
                    {'Click to open Work Reporting'}
                </a>
            ),
        },
        {
            field: 'action',
            headerName: 'Delete Template',
            disableExport: true,
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <div>
                    <div>
                        <IconButton className={styles.button} onClick={() => { handleDelete(params) }}>
                            <Delete />
                        </IconButton>
                    </div>
                </div>
            )
        }
    ]


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />

            <>
                <Dialog
                    open={dialogObj.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogObj.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={deleteDialog}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>

            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    {findWorkOrder &&
                        <FindWorkOrder setFindWorkOrder={setFindWorkOrder} findWorkOrder={findWorkOrder} setWoid={setWoid} woid={woid}/>
                    }

                    <CreateSchedule setCreateScheduleShow={setCreateScheduleShow} createScheduleShow={createScheduleShow} setScheduleCreate={setScheduleCreate} schedeuleCreate={scheduleCreate} />
                    <Grid
                        container
                        border={0}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        height={'100%'}
                        width={'100%'}
                    >
                        <>
                            <Grid item border={0} marginRight={1} md={12} xs={12}>
                                {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                <DataGridPremium
                                    rows={templateData}
                                    columns={columns}
                                    autoHeight={true}
                                    density={'compact'}
                                    pageSize={10}
                                    loading={false}
                                    disableMultipleSelection={true}
                                    // onRowClick={handleRowClick}
                                    onRowDoubleClick={handleRowClick}
                                />
                            </Grid>
                            <Grid item border={0} marginTop={3} marginRight={1} md={12} xs={12}>
                                {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                <DataGridPremium
                                    rows={workReportingData}
                                    columns={workreportingcolumns}
                                    autoHeight={true}
                                    density={'compact'}
                                    pageSize={10}
                                    loading={false}
                                    disableMultipleSelection={true}
                                    disableSelectionOnClick={true}
                                    // onRowClick={handleRowClick}
                                    // onRowDoubleClick={handleRowClick}
                                />
                            </Grid>
                        </>
                    </Grid>
                </div>
            </>
        </div>
    )
}

export default WorkReportingTemplates